'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



//////////////////
// WEBPACK FOOTER
// ../strict-uri-encode/index.js
// module id = 1398
// module chunks = 25